import { render, staticRenderFns } from "./SSOKeyCloakUatLogin.vue?vue&type=template&id=c2051304"
import script from "./SSOKeyCloakUatLogin.vue?vue&type=script&lang=js"
export * from "./SSOKeyCloakUatLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports